import { UuidableName } from 'utils/api/types';

export const LONE_WORKING_REPORTING_DASHBOARD_TYPES = [
  { key: 'loneWorkingReportingSummary', slug: 'summary', name: 'Summary' },
  { key: 'loneWorkingReportingApp', slug: 'app', name: 'Lone Worker App' },
  { key: 'loneWorkingReportingDevices', slug: 'devices', name: 'Lone Worker Devices' },
  { key: 'loneWorkingReportingAlarm', slug: 'alarm-activations', name: 'Alarm Activations' },
] as const;

export const getFirstAvailableLoneWorkingReportingSlug = (
  loneWorkingReporting: Record<string, UuidableName[]> | null | undefined
): string =>
  LONE_WORKING_REPORTING_DASHBOARD_TYPES.find(({ key }) => (loneWorkingReporting?.[key]?.length ?? 0) > 0)?.slug ??
  LONE_WORKING_REPORTING_DASHBOARD_TYPES[0].slug;
